import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Privacy from "./pages/Privacy.js";
import RefundPolicy from "./pages/RefundPolicy.js";
import Register from "./pages/Register.js";
import Services from "./pages/Services";
import Terms from "./pages/Terms.js";
import ApplicationForm from "./components/carrerPage";
import SignAggrement from "./pages/signAggrement.js";
import MandateFailure from "./pages/mandateFailure.js";


function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <div className="flex-grow">
          {/* <Navbar /> */}
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<About />} />
            <Route path="/about" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/refundpolicy" element={<RefundPolicy />} />
            <Route path="/career" element={<ApplicationForm />} />
            <Route path="/sign-aggrement/:id" element={<SignAggrement />} />
            <Route path="/mandate-failure/:id" element={<MandateFailure />} />
          </Routes>
          {/* <Footer /> */}
        </div>
      </div>
    </Router>
  );
}

export default App;
